import "./style.css"

const Card = () => {
   return <h1 className = "tituloPrincipal" > Olá Kenzinho </h1>
}

export default Card